import AddToCalendarUI from './AddToCalendarUI';
import { trackLinkClick } from '../../../helpers/analytics';

interface AddToCalendarProps {
  title: string;
  description?: string;
  epochStart: number;
  length: number;
  location?: string;
}

function AddToCalendar(props: AddToCalendarProps) {
  const { title, location } = props;
  return (
    <AddToCalendarUI
      {...props}
      onClick={() => {
        trackLinkClick('Add to calendar', title, location);
      }}
    />
  );
}

export default AddToCalendar;
